import React from 'react'
import {Route, Switch} from "react-router";
import {Main} from './Main'
import {Details} from "./Details";

export const Products = () => {
    return (
        <React.Fragment>
            <Switch>
                <Route path={'/place/products/:id/:slug'} component={Details}/>
                <Route component={Main}/>
            </Switch>
        </React.Fragment>
    )
}